import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import moment from 'moment'
import Modal from 'react-responsive-modal'
import { navigateTo } from 'gatsby-link'
import ProductSummary from '@components/ProductSummary'
import Button from '@components/Button'
import DateRangeForm from '@components/DateRangeForm'
import BasketHelper from '@helpers/BasketHelper'
import { basketRoute } from '@constants/routes'
import './BookingForm.module.scss'

const getPpe = R.pipe(
  R.pathOr([], ['product', 'ppe']),
  R.map(R.prop('title'))
)

class BookingForm extends Component {
  state = {
    open: false,
    redirect: false,
    startDateFocused: false,
    endDateFocused: false,
    product: {
      title: R.pathOr('', ['product', 'title'], this.props),
      slug: R.pathOr('', ['product', 'slug'], this.props),
      ppe: getPpe(this.props),
      image: R.pathOr(null, ['product', 'image', 'resize', 'src'], this.props),
      optionalExtras: R.pathOr([], ['product', 'optionalExtras'], this.props),
      productCode: R.path(['product', 'productCode'], this.props),
      quantity: '1',
      startDate: moment(),
      endDate: moment().add(1, 'day')
    }
  }

  componentDidMount () {
    this.setState({ items: BasketHelper.getItems })
  }

  onClick = () => {
    const { product } = this.state
    const items = BasketHelper.getItems()

    items.push(product)
    BasketHelper.addItems(items)

    this.setState({ addedToBasket: true })
  }

  addProduct = () => {
    const { product } = this.state
    const items = BasketHelper.getItems()

    items.push(product)
    BasketHelper.addItems(items)

    this.setState({ open: true })
  }

  onCloseModal = () => {
    this.setState({ open: false })
  }

  onExitModal = () => {
    const { redirect } = this.state

    redirect && navigateTo(basketRoute)
  }

  addOptionalExtras = (extras, redirect = false) => {
    const items = BasketHelper.getItems()
    items.push(...extras)
    BasketHelper.addItems(items)

    this.onCloseModal()

    this.setState({ redirect })
  }

  onQuantityChange = (e) => {
    const { product } = this.state
    const quantity = e.target.value

    this.setState({
      product: {
        ...product,
        quantity
      }
    })
  }

  onStartDateChange = (startDate) => {
    const { product } = this.state
    const newState = { startDate }
    const endDate = R.prop('endDate', product)

    if (startDate.isSameOrAfter(endDate, 'day')) {
      newState.endDate = moment(startDate).add(1, 'days')
    }

    this.setState({
      product: {
        ...product,
        ...newState
      }
    })
  }

  onStartDateFocusChange = ({ focused }) => {
    this.setState({ startDateFocused: focused })
  }

  onEndDateChange = (endDate) => {
    const { product } = this.state
    const newState = { endDate }
    const startDate = R.prop('startDate', product)

    if (endDate.isSameOrBefore(startDate, 'day')) {
      newState.startDate = moment(endDate).add(-1, 'days')
    }

    this.setState({
      product: {
        ...product,
        ...newState
      }
    })
  }

  onEndDateFocusChange = ({ focused }) => {
    this.setState({ endDateFocused: focused })
  }

  render () {
    const { open, product, startDateFocused, endDateFocused } = this.state
    const startDate = R.prop('startDate', product)
    const endDate = R.prop('endDate', product)
    const quantity = R.prop('quantity', product)

    return (
      <div styleName='container'>
        <DateRangeForm
          startDate={startDate}
          startDateFocused={startDateFocused}
          onStartDateChange={this.onStartDateChange}
          onStartDateFocusChange={this.onStartDateFocusChange}
          endDate={endDate}
          endDateFocused={endDateFocused}
          onEndDateChange={this.onEndDateChange}
          onEndDateFocusChange={this.onEndDateFocusChange}
          onQuantityChange={this.onQuantityChange}
          quantity={quantity}
        />

        <div styleName='buttonWrapper'>
          <Button click={this.addProduct}>
            Add to Hire Quote List
          </Button>
        </div>

        <Modal
          open={open}
          onClose={this.onCloseModal}
          onExited={this.onExitModal}
          classNames={{ overlay: 'bss-overlay', modal: 'bss-modal' }}
        >
          <ProductSummary
            product={product}
            addOptionalExtras={this.addOptionalExtras}
          />
        </Modal>

      </div>
    )
  }
}

BookingForm.propTypes = {
  product: PropTypes.object.isRequired
}

export default BookingForm



// WEBPACK FOOTER //
// ./src/components/BookingForm/BookingForm.js